import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../../app/store';
import { updateSelectedContract } from '../../../../../../services/ContractService/contractSlice';

const ThresholdTypeEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);

  const handleChange = (value: string) => {
    if (!contract) return;

    dispatch(updateSelectedContract({
      implants: {
        ...contract.implants,
        thresholdType: value
      }
    }));
  };

  if (!contract) return null;

  const thresholdTypes = [
    { value: 'NA', label: 'Not Applicable' },
    { value: 'Fixed', label: 'Fixed Amount' },
    { value: 'Percentage', label: 'Percentage' }
  ];

  return (
    <FormControl fullWidth size="small">
      <InputLabel>Threshold Type</InputLabel>
      <Select
        value={contract.implants?.thresholdType ?? 'NA'}
        onChange={(e) => handleChange(e.target.value)}
        label="Threshold Type"
      >
        {thresholdTypes.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ThresholdTypeEditor;